<section class="hero">
  <span class="hero__badge">Angular {{ major }} · Material {{ major }}</span>
  <h1 class="hero__h1">ngx-aur-mat-table</h1>
  <p class="hero__tag">Config-driven tables for Angular Material</p>
  <p class="hero__feat">
    <b>pagination</b> · <b>sorting</b> · <b>selection</b> · <b>actions</b> · <b>filtering</b>
    — {{ demos.length }} live demos
  </p>
  <div class="hero__install">
    <span><span class="p">$</span> <span class="c">{{ installCmd }}</span></span>
    <button class="hero__copy" type="button" aria-live="polite" (click)="copyInstall()">{{ copied ? '✓ copied' : '⧉ copy' }}</button>
  </div>
  <div class="hero__cta">
    <button class="btn btn--p" type="button" (click)="scrollToCatalog()">Browse {{ demos.length }} demos ↓</button>
    <a class="btn btn--o" [href]="githubUrl" target="_blank" rel="noopener">GitHub ★</a>
  </div>
</section>

<main class="cat" id="demo-catalog">
  <div class="cat__bar">
    <label class="cat__search">🔍<input type="search" placeholder="Search demos…" aria-label="Search demos" [(ngModel)]="query"></label>
    <button type="button" class="chip" [class.chip--on]="selected === 'All'" [attr.aria-pressed]="selected === 'All'" (click)="select('All')">
      All <i>{{ demos.length }}</i>
    </button>
    <button *ngFor="let cat of categories" type="button" class="chip"
            [class.chip--on]="selected === cat" [attr.aria-pressed]="selected === cat" (click)="select(cat)">
      {{ cat }} <i>{{ count(cat) }}</i>
    </button>
  </div>

  <ng-container *ngFor="let cat of shownCategories">
    <section *ngIf="visible(cat).length" class="sec">
      <div class="sec__h"><h2>{{ cat }}</h2><span>{{ visible(cat).length }} demos</span></div>
      <div class="grid">
        <a *ngFor="let d of visible(cat)" class="dcard" [routerLink]="['/demo', d.slug]">
          <b>{{ d.title }}</b>
          <p>{{ d.description }}</p>
        </a>
      </div>
    </section>
  </ng-container>

  <p *ngIf="!anyVisible" class="cat__empty">No demos match “{{ query }}”.</p>
</main>
